/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { AlertminerApiConfiguration as __Configuration } from '../alertminer-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class EntityOpportunityClientService extends __BaseService {
  static readonly GetOpportunitiesForEntityByEntityidGETPath = '/api/EntityOpportunity/GetOpportunitiesForEntity/{entityId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param entityId undefined
   */
  GetOpportunitiesForEntityByEntityidGETResponse(entityId: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/EntityOpportunity/GetOpportunitiesForEntity/${entityId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param entityId undefined
   */
  GetOpportunitiesForEntityByEntityidGET(entityId: string): __Observable<null> {
    return this.GetOpportunitiesForEntityByEntityidGETResponse(entityId).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module EntityOpportunityClientService {
}

export { EntityOpportunityClientService }
